import React, { Component } from "react";
import "../Account.css"
import SignupHeader from "./signup.header";
import SignupFooter from "./signup.footer";
import { Link } from "react-router-dom";
import axios from "axios";



class PasswordReset extends Component {
  state = {
    // email: '',
    password: '',
    confirmPassword: '',
    error: null,
  };

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleSubmit = async (event) => {
    event.preventDefault();

    
    if (this.state.password !== this.state.confirmPassword) {
      this.setState({ error: 'Passwords do not match' });
      return;
    }
    try {
      // const Uid = parseInt(this.props.Uid.Uid, 10);
      const Uid = this.props.Uid.Uid;
      const token = this.props.Uid.token
      const response = await axios.post(`https://api.geoinfoacademy.com/api/password-reset-confirm/${Uid}/${token}/`, {
        // email: this.state.email,
        // password: this.state.password,
        new_password: this.state.confirmPassword,
      });

      // Handle successful signup (e.g., display a success message)
      console.log('Signup successful:', response.data);
      // Optionally, redirect the user to the login page
      console.log('Redirecting to dashboard')
      window.location.href = '/login';
    } catch (error) {
      this.setState({ error: 'Password change failed. Please try again.' });
      console.log(error)
      setTimeout(() => {
        this.setState({ error: '' });
      }, 5000); 
    }
  };
  render() {
    return (
      <div className=" account_body ">
        <SignupHeader />
        <h1 className="account_header">Reset Password</h1>
        <div className="account_form_cover">
          <form className="account_form" onSubmit={this.handleSubmit}>
            <label htmlFor="password">Password</label><br />
            <input placeholder="Enter Your Password" type="password" id="password" name="password" value={this.state.password} onChange={this.handleChange} required/><br /><br />
            <label htmlFor="confirmPassword">Comfirm Password</label><br />
            <input placeholder="Enter Your Comfirm Password" type="password" id="confirmPassword" name="confirmPassword" value={this.state.confirmPassword} onChange={this.handleChange} required /><br /><br />
            <button type="submit">Submit</button> <br />
            {this.state.error && <p className="account_error">{this.state.error}</p>}<br />
            <p>Remember your password? <Link to="/login"><span>Login</span></Link></p>
          </form>
        </div>
        <SignupFooter />
      </div>
    )
  }
}

export default PasswordReset